import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [
  { category: 'budget', paid: 7000, debt: 1000 },
  { category: 'industry', paid: 6800, debt: 2000 },
  { category: 'energy', paid: 1220, debt: 1000 },
  { category: 'religion', paid: 900, debt: 1000 },
  { category: 'population', paid: 4200, debt: 2000 },
];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/paymen-by-categories.*/)
  .reply(200, mock)
  .onAny()
  .passThrough();
